const cookie = require('js-cookie');
const help = require('help');

(
    function($)
    {
        $.fn.notice = function(params)
        {
            $(this).each
            (
                function()
                {
                    const self = this;
                    const textCookie = cookie.get('notice');
                    const text = help.trim(params.text.html());

                    if((textCookie == undefined && text != '') || (text !== textCookie && text != ''))
                    {
                        $(this).addClass('notice--show');
                    }
                    else
                    {
                        $(this).removeClass('notice--show');
                    }

                    params.close.click(function()
                    {
                        $(self).fadeOut(250, function()
                        {
                            cookie.set('notice', text,
                                {
                                    expires: 365
                                }
                            );

                            $(self).addClass('notice--show');
                        });
                    });
                }
            );
        }
    }
)(jQuery);
